$(document).ready(function () {
  var app_dom = $("#app");
  var page = app_dom.attr("data-page");
  var lang = app_dom.attr("data-lang");

  APP.init(page, lang);
  UTILS.init();
  FORMS.init();
  ANIMS.init();
  CART.init();
  APP.updateMenuBadgeNumber(".menu-cart", CART.cartLength());
  // console.log('page == "' + page + '"');

  if (page == "home" || page == "wineries" || page == "experiences") {
    LISTING.init();

    let viewType = localStorage.getItem("view");
    if (viewType) {
      console.log($(".view-by-selector .is-" + viewType));
      LISTING.changeView($(".view-by-selector .is-" + viewType), viewType);
    }
  }
  console.log(page);
  if (page === "winery_regions_detail") {
    LISTING.init(false, false);

    if (LISTING.features.length) {
      // based on these
      // https://programming.vip/docs/polygon-drawing-with-openlayer-given-coordinates.html
      // https://openlayers.org/en/latest/examples/center.html
      var coordinates = LISTING.features.map((f) =>
        f.feature.getGeometry().getCoordinates()
      );
      var plygon = new ol.geom.Polygon([coordinates]);
      APP.map.getView().fit(plygon, {
        padding: [80, 80, 80, 80],
        maxZoom: 10,
      });
    }
  }
  if (page == "wineries_detail" || page == "experiences_detail") {
    //something

    $(".hero-background .slider").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      dots: true,
    });

    $(".reviews-slider").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      dots: true,
      appendArrows: $(".slider-navigation"),
      appendDots: $(".slider-navigation"),
    });
    console.log("seting up map detail");

    var $map = $(".osm-map");
    var feature = new ol.Feature({
      geometry: new ol.geom.Point(
        ol.proj.fromLonLat([$map.attr("data-lon"), $map.attr("data-lat")])
      ),
    });
    feature.setStyle(
      new ol.style.Style({
        image: new ol.style.Icon({
          src: "assets/images/pin-map.png",
          anchor: [0.5, 1],
          scale: 0.4,
          color: "#c52973",
        }),
      })
    );
    var vectorLayer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: [feature],
      }),
    });

    var view = new ol.View({
      center: ol.proj.fromLonLat([
        $map.attr("data-lon"),
        $map.attr("data-lat"),
      ]),
      zoom: 12,
    });

    APP.setupMap($map.get(0), view, false, false);
    APP.map.addLayer(vectorLayer);
  }
  if (page == "experiences_booking") {
    $(".other-experience-group .title-group").click(function () {
      $(this).parent(".other-experience-group").toggleClass("is-active");
      $(this).siblings(".panel").slideToggle();
    });
    BOOKING.init();
    TXAPP.init();
  }
  if (page == "cart") {
    CART.drawCart();
  }
  if (page == "checkout") {
    $('.payment-option input[type="radio"]').change(function () {
      $(".payment-option-extra").slideUp();
      $(this)
        .parents(".payment-option")
        .find(".payment-option-extra")
        .slideDown();
    });
  }

  // Input register 
  const inputs = document.querySelectorAll('.code-input');
  inputs.forEach((input, index) => {
    // Evento para colar o código
    input.addEventListener('paste', (e) => {
      e.preventDefault();
      const pastedData = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');

      if (pastedData.length >= 4) {
        for (let i = 0; i < 4 && i < pastedData.length; i++) {
          inputs[i].value = pastedData[i];
        }
        inputs[Math.min(3, pastedData.length - 1)].focus();
      }
    });

    // Evento para digitação
    input.addEventListener('input', (e) => {
      const value = e.target.value.replace(/\D/g, '');
      e.target.value = value;

      if (value && index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
    });

    // Navegação com backspace
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Backspace' && !e.target.value && index > 0) {
        inputs[index - 1].focus();
      }
    });
  });
});
